module.exports = __webpack_public_path__ + "img/roller_coaster.aa511c96.gif";